export default __webpack_public_path__ + "static/media/thumbnail.df620710.png";